import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getDashboardData } from "../slice/contactUsSlice";
import {
  FaUsers,
  FaCalendarAlt,
  FaBriefcase,
  FaBlog,
  FaUserGraduate,
  FaComments
} from "react-icons/fa";

function Home() {
  const dispatch = useDispatch();
  const Data = useSelector((state) => state.contactus);
  const { table_counts } = Data.data || {};

  useEffect(() => {
    dispatch(getDashboardData());
  }, [dispatch]);

  // 🔹 Internal CSS (Dashboard Fix + Premium Cards)
  const dashboardStyle = `
    .dashboard-title-main {
      font-size: 26px;
      font-weight: 700;
      color: #111827;
    }

    .dashboard-card {
      background: #ffffff;
      border-radius: 14px;
      position: relative;
      padding: 22px;
      transition: all 0.3s ease;
      cursor: pointer;
    }

    .dashboard-card:hover {
      transform: translateY(-6px);
      box-shadow: 0 16px 32px rgba(0, 0, 0, 0.12);
    }

    .left-bar {
      position: absolute;
      top: 16px;
      bottom: 16px;
      left: 0;
      width: 6px;
      border-radius: 0 6px 6px 0;
    }

    .bar-amber { background: #f59e0b; }
    .bar-indigo { background: #6366f1; }
    .bar-emerald { background: #10b981; }
    .bar-sky { background: #0ea5e9; }
    .bar-rose { background: #f43f5e; }
    .bar-slate { background: #64748b; }

    .card-label {
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 0.08em;
      color: #6b7280;
    }

    .card-count {
      font-size: 30px;
      font-weight: 700;
      color: #111827;
      margin-top: 4px;
    }

    .icon-box {
      width: 46px;
      height: 46px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 20px;
    }

    .icon-amber { background: #f59e0b; }
    .icon-indigo { background: #6366f1; }
    .icon-emerald { background: #10b981; }
    .icon-sky { background: #0ea5e9; }
    .icon-rose { background: #f43f5e; }
    .icon-slate { background: #64748b; }
  `;

  return (
    <>
      <style>{dashboardStyle}</style>

      <div className="container-fluid px-lg-5 mt-5">

        {/* ✅ FIXED DASHBOARD TITLE */}
        <div className="mb-4">
          <h1 className="dashboard-title-main">Dashboard</h1>
        </div>

        <div className="row mt-4">

          {/* Total Resume */}
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="dashboard-card">
              <span className="left-bar bar-amber"></span>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="card-label">TOTAL RESUME</div>
                  <div className="card-count">{table_counts?.appointment || 0}</div>
                </div>
                <div className="icon-box icon-amber">
                  <FaCalendarAlt />
                </div>
              </div>
            </div>
          </div>

          {/* Contact Enquiries */}
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="dashboard-card">
              <span className="left-bar bar-indigo"></span>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="card-label">CONTACT ENQUIRIES</div>
                  <div className="card-count">{table_counts?.contactus || 0}</div>
                </div>
                <div className="icon-box icon-indigo">
                  <FaComments />
                </div>
              </div>
            </div>
          </div>

          {/* Team */}
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="dashboard-card">
              <span className="left-bar bar-emerald"></span>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="card-label">TEAM MEMBERS</div>
                  <div className="card-count">{table_counts?.ourteam || 0}</div>
                </div>
                <div className="icon-box icon-emerald">
                  <FaUsers />
                </div>
              </div>
            </div>
          </div>

          {/* Blogs */}
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="dashboard-card">
              <span className="left-bar bar-sky"></span>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="card-label">BLOG POSTS</div>
                  <div className="card-count">{table_counts?.blog || 0}</div>
                </div>
                <div className="icon-box icon-sky">
                  <FaBlog />
                </div>
              </div>
            </div>
          </div>

          {/* Jobs */}
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="dashboard-card">
              <span className="left-bar bar-rose"></span>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="card-label">JOB OPENINGS</div>
                  <div className="card-count">{table_counts?.job || 0}</div>
                </div>
                <div className="icon-box icon-rose">
                  <FaBriefcase />
                </div>
              </div>
            </div>
          </div>

          {/* Internship */}
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="dashboard-card">
              <span className="left-bar bar-slate"></span>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="card-label">INTERNSHIP APPLY</div>
                  <div className="card-count">{table_counts?.internship || 0}</div>
                </div>
                <div className="icon-box icon-slate">
                  <FaUserGraduate />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default Home;
